export default __webpack_public_path__ + "assets/images/a2ededbac5d44a6a60cdaa6633505c5d.svg";